<template>
  <div class="modal-panel">
    <div class="modal-head">
      <h3 class="modal-title">{{ titulo }} ejercicio</h3>
      <p class="modal-sub">Los campos con * son obligatorios</p>
    </div>

    <div class="modal-body">
      <div class="field-row">
        <div class="field">
          <label class="field-label">Nombre *</label>
          <v-text-field v-model="ejercicioLocal.nombre" :error-messages="errores.nombre" outlined dense
            hide-details="auto" placeholder="Ej. Sentadilla con barra" class="dark-input"></v-text-field>
        </div>
        <div class="field">
          <label class="field-label">Categoría *</label>
          <v-select v-model="ejercicioLocal.categoria_id" :items="categorias" item-text="nombre" item-value="id"
            :error-messages="errores.categoria_id" outlined dense hide-details="auto" placeholder="Selecciona"
            class="dark-input"></v-select>
        </div>
      </div>

      <div class="field">
        <label class="field-label">Descripción</label>
        <v-textarea v-model="ejercicioLocal.descripcion" outlined dense rows="2" hide-details="auto"
          placeholder="Describe brevemente el ejercicio" class="dark-input"></v-textarea>
      </div>

      <div class="field">
        <label class="field-label">Instrucciones</label>
        <v-textarea v-model="ejercicioLocal.instrucciones" outlined dense rows="3" hide-details="auto"
          placeholder="Pasos para ejecutar el ejercicio correctamente" class="dark-input"></v-textarea>
      </div>

      <div class="field-row">
        <div class="field">
          <label class="field-label">URL de la imagen</label>
          <v-text-field v-model="ejercicioLocal.imagen_url" outlined dense hide-details="auto"
            placeholder="https://…" class="dark-input"></v-text-field>
        </div>
        <div class="field">
          <label class="field-label">URL del video</label>
          <v-text-field v-model="ejercicioLocal.video_url" outlined dense hide-details="auto"
            placeholder="https://…" class="dark-input"></v-text-field>
        </div>
      </div>

      <div class="field-row field-row-3">
        <div class="field">
          <label class="field-label">MET (energía consumida)</label>
          <v-text-field v-model="ejercicioLocal.met" type="number" outlined dense hide-details="auto"
            placeholder="0" class="dark-input"></v-text-field>
        </div>
        <div class="field">
          <label class="field-label">Nivel de dificultad</label>
          <v-select v-model="ejercicioLocal.nivel_dificultad" :items="nivelesDificultad" outlined dense
            hide-details="auto" placeholder="Selecciona" class="dark-input"></v-select>
        </div>
        <div class="field">
          <label class="field-label">Equipamiento</label>
          <v-select v-model="ejercicioLocal.equipamiento" :items="tiposEquipamiento" outlined dense
            hide-details="auto" placeholder="Selecciona" class="dark-input"></v-select>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-ghost" @click="cerrar">Cancelar</button>
      <button class="btn-primary" :disabled="!esValido" @click="guardar">Guardar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormEjercicio",
  props: {
    ejercicio: {
      type: Object,
      default: () => ({})
    },
    titulo: {
      type: String,
      default: "Agregar"
    },
    categorias: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      ejercicioLocal: { ...this.ejercicio },
      errores: {
        nombre: "",
        categoria_id: ""
      },
      nivelesDificultad: ['principiante', 'intermedio', 'avanzado'],
      tiposEquipamiento: ['peso corporal', 'mancuernas', 'barra', 'kettlebell', 'bandas elásticas', 'máquina', 'balón medicinal', 'steps']
    };
  },
  computed: {
    esValido() {
      return this.ejercicioLocal.nombre &&
        this.ejercicioLocal.nombre.trim() !== "" &&
        this.ejercicioLocal.categoria_id;
    }
  },
  watch: {
    ejercicio: {
      handler(nuevoValor) {
        this.ejercicioLocal = { ...nuevoValor };
      },
      deep: true
    },
    'ejercicioLocal.nombre': function (valor) {
      this.validarNombre(valor);
    },
    'ejercicioLocal.categoria_id': function (valor) {
      this.validarCategoria(valor);
    }
  },
  methods: {
    validarNombre(nombre) {
      if (!nombre || nombre.trim() === "") {
        this.errores.nombre = "El nombre es obligatorio";
      } else {
        this.errores.nombre = "";
      }
    },
    validarCategoria(categoriaId) {
      if (!categoriaId) {
        this.errores.categoria_id = "La categoría es obligatoria";
      } else {
        this.errores.categoria_id = "";
      }
    },
    cerrar() {
      this.$emit('cerrado', false);
    },
    guardar() {
      if (this.esValido) {
        this.$emit('registrar', { ...this.ejercicioLocal });
      }
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500;700&family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@500&display=swap');

/* ===== TOKENS ===== */
.modal-panel {
  --bg: #0E0E10;
  --card: #17171A;
  --card-border: #26262A;
  --text-primary: #F2F2ED;
  --text-secondary: #8C8C93;
  --text-tertiary: #5C5C62;
  --accent: #C8FF4D;
  --error: #FF6B6B;
  --radius: 4px;

  --font-display: 'Space Grotesk', sans-serif;
  --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;

  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  overflow: hidden;
  font-family: var(--font-body);
  color: var(--text-primary);
}

.modal-head {
  padding: 22px 24px;
  border-bottom: 1px solid var(--card-border);
}

.modal-title {
  font-family: var(--font-display);
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 4px;
  text-transform: capitalize;
}

.modal-sub {
  font-size: 12.5px;
  color: var(--text-secondary);
  margin: 0;
}

.modal-body {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 65vh;
  overflow-y: auto;
}

.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.field-row-3 {
  grid-template-columns: 1fr 1fr 1fr;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-secondary);
  text-transform: uppercase;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--card-border);
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--accent);
  color: var(--bg);
  border: none;
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btn-primary:hover:not(:disabled) {
  filter: brightness(1.08);
}

.btn-primary:disabled {
  opacity: 0.45;
  cursor: default;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--card-border);
  border-radius: var(--radius);
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease;
}

.btn-ghost:hover {
  border-color: var(--text-tertiary);
  color: var(--text-primary);
}

/* ===== Overrides Vuetify (v-text-field, v-select, v-textarea) ===== */
.dark-input >>> .v-input__slot {
  background: var(--bg) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  min-height: 42px !important;
}

.dark-input >>> fieldset {
  border-color: var(--card-border) !important;
  border-width: 1px !important;
  border-radius: 4px !important;
  transition: border-color 0.15s ease;
}

.dark-input >>> .v-input--is-focused fieldset {
  border-color: var(--accent) !important;
  border-width: 1.5px !important;
}

.dark-input >>> input,
.dark-input >>> textarea,
.dark-input >>> .v-select__selection {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 14px !important;
  caret-color: var(--accent) !important;
  text-transform: none;
}

.dark-input >>> input::placeholder,
.dark-input >>> textarea::placeholder {
  color: var(--text-tertiary) !important;
  opacity: 1 !important;
}

.dark-input >>> .v-icon {
  color: var(--text-tertiary) !important;
}

.dark-input >>> .v-messages {
  color: var(--error) !important;
}

/* Menú desplegable de los v-select */
.modal-panel >>> .v-menu__content {
  background: var(--card) !important;
  border: 1px solid var(--card-border) !important;
  border-radius: 4px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5) !important;
}

.modal-panel >>> .v-list {
  background: transparent !important;
  padding: 4px !important;
}

.modal-panel >>> .v-list-item {
  border-radius: 4px !important;
  text-transform: capitalize;
}

.modal-panel >>> .v-list-item__title {
  color: var(--text-primary) !important;
  font-family: var(--font-body) !important;
  font-size: 13px !important;
}

.modal-panel >>> .v-list-item:hover {
  background: rgba(255, 255, 255, 0.04) !important;
}

.modal-panel >>> .v-list-item--active {
  background: rgba(200, 255, 77, 0.12) !important;
}

.modal-panel >>> .v-list-item--active .v-list-item__title {
  color: var(--accent) !important;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 500px) {
  .field-row,
  .field-row-3 {
    grid-template-columns: 1fr;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Planes/FormEjercicio.vue